import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Button, Container } from 'react-bootstrap';
import DateFormat from '../../../commons/componentes/DateFormat';

const GrupoContactoTable = (props: any) => {

    const { grupoId, empresaId, contactos, seleccionarEmpresa }: { grupoId: string; empresaId: string, contactos: any[], seleccionarEmpresa?: any } = props;

    const dispatch = useDispatch();


    console.log('App loading');



    return (
        <div style={{ overflowX: 'auto', width: '100%' }}>
            <table className="table tabla-chica" style={{ minWidth: 700 }}>
                <thead>
                    <tr className='bg-primary'>
                        <th>Contacto</th>
                        <th>Fecha Nacimiento</th>
                        <th>T. Oficina</th>
                        <th>T. Oficina 2</th>
                        <th>T. Móvil</th>
                        <th>T. Móvil 2</th>
                        <th>Correo</th>
                        <th>Correo 2</th>
                    </tr>
                </thead>
                <tbody>
                    {contactos.map((contacto, index: number) => (
                        <tr key={contacto.id ?? index}>
                            <td>{contacto.contacto}</td>
                            <td><DateFormat value={contacto.fechaNacimiento}></DateFormat></td>
                            <td>{contacto.telefonoOficinaPrimario}</td>
                            <td>{contacto.telefonoOficinaSecundario}</td>
                            <td>{contacto.telefonoMovilPrimario}</td>
                            <td>{contacto.telefonoMovilSecundario}</td>
                            <td>{contacto.correoElectronicoPrimario}</td>
                            <td>{contacto.correoElectronicoSecundario}</td>
                        </tr>
                    ))}
                </tbody>
            </table>
        </div>
    );
}

export default GrupoContactoTable;
